import { Node_Type } from "./../../ricos-types";
import Giphy from "./giphy";
const nodeViewRenderers = {
  [Node_Type.GIF]: Giphy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
